// extracted by mini-css-extract-plugin
module.exports = {"indicator":"components-LoadingIndicator-___LoadingIndicator__indicator___3jqN1","icon":"components-LoadingIndicator-___LoadingIndicator__icon___1sAi5"};